import { FREE_PLAN } from './planMarketing'

export const LANDING_FAQ = [
  {
    question: 'What is Pingscalate?',
    answer:
      'Pingscalate is an uptime monitoring service that checks your websites and APIs on a schedule, shows a clear status dashboard, and sends Slack or email alerts when something fails.',
  },
  {
    question: 'Is there a free plan?',
    answer: `Yes. The free plan includes ${FREE_PLAN.monitors} monitors with ${FREE_PLAN.intervalMinutes}-minute check intervals, Slack and email alerts, a public status page, SSL/domain expiry monitoring, and escalation policies—no credit card required.`,
  },
  {
    question: 'How do Slack uptime alerts work?',
    answer:
      'Connect your Slack workspace in settings. When a monitor fails, Pingscalate posts an alert to your chosen channel. Escalation policies let you control who gets notified and when.',
  },
  {
    question: 'Can I send alerts to email instead of Slack?',
    answer:
      'Yes. Add email recipients on your escalation policies. Alerts go to Slack, email, or both depending on how you configure each policy.',
  },
  {
    question: 'Can I share uptime with customers?',
    answer:
      'Yes. Create a public status page with a custom URL. It shows monitor status, uptime percentages, and charts—updated automatically as checks run.',
  },
  {
    question: 'Can I monitor APIs and endpoints behind Cloudflare?',
    answer:
      'Yes. Pingscalate supports GET and POST requests, browser-like user agents, and custom headers—useful when strict filters block basic uptime checkers.',
  },
  {
    question: 'How often are sites checked?',
    answer: `The free plan runs checks every ${FREE_PLAN.intervalMinutes} minutes. Pro and Max plans offer checks as fast as every 2 or 1 minute. SSL and domain monitors run on a daily schedule.`,
  },
  {
    question: 'What happens when a site goes down?',
    answer:
      'Pingscalate marks the monitor as down in your status view, logs the failure, and sends Slack or email alerts based on your escalation policy. Failed checks are rechecked at your policy interval; persistent failures can escalate to high-priority alerts.',
  },
  {
    question: 'Do I need to install anything on my servers?',
    answer:
      'No. Pingscalate runs scheduled checks from the cloud. Add a URL, set your check options, and you are done.',
  },
  {
    question: 'Can I monitor SSL certificates and domain expiry?',
    answer:
      'Yes. Add SSL certificate or domain registration monitors to get alerts before they expire. Checks run on a daily schedule (or less often) and use the same Slack and email escalation policies as website monitors.',
  },
  {
    question: 'Can I monitor more than websites?',
    answer:
      'Yes. Monitor any HTTP endpoint—REST APIs, webhooks, health-check URLs, and staging environments—as long as they respond over HTTP or HTTPS.',
  },
] as const
